class MiniCart extends HTMLElement {
  constructor() {
    super();

    //add event listeners
    this.timeout;
    this.addListeners();
    this.drawer = document.querySelector("#drawer-mini-cart");
    this.miniCartToggles = document.querySelectorAll(".js-mini-cart-toggle");
    this.cartAddUnsubscriber = undefined;
    this.cartUpdateUnsubscriber = undefined;

    document.addEventListener("cart:added", () => {
      if (!this.drawer.classList.contains("active")) {
        this.drawer.dispatchEvent(new Event("drawer-toggle"));
      }
    });
  }

  connectedCallback() {
    this.cartAddUnsubscriber = subscribe(PUB_SUB_EVENTS.cartAdd, () => {
      this.drawer.classList.add("added");
      this.renderCart();
    });

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      this.renderCart();
    });
  }

  disconnectedCallback() {
    if (this.cartAddUnsubscriber) {
      this.cartAddUnsubscriber();
    }

    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  //quantity input change
  handleInputChange(input, key) {
    let lineKey = key;
    let quantity = 0;

    if (input && input.getAttribute("data-key")) {
      lineKey = input.getAttribute("data-key");
    }

    if (input && input.value) {
      quantity = parseInt(input.value);
    }

    if (lineKey && quantity >= 0) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(() => {
        this.classList.add("loading");

        const body = JSON.stringify({
          id: lineKey,
          quantity: quantity,
          sections: "cart-drawer",
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
          .then((res) => {
            return res.text();
          })
          .then((data) => {
            const sectionHtml = JSON.parse(data).sections["cart-drawer"];
            this.renderCart(sectionHtml);
          })
          .catch((e) => {
            console.error(e);
            this.classList.remove("loading");
          });
      }, 300);
    } else {
      this.classList.remove("loading");
      console.error("No line item details");
    }
  }

  updateItemCount(count) {
    const cartItemCount = document.querySelector(".js-cart-item-count");
    const cartItemCountLabel = document.querySelector(
      ".js-cart-item-count-label"
    );

    if (cartItemCount) {
      cartItemCount.innerText = count;
    }

    if (cartItemCountLabel) {
      cartItemCountLabel.innerText = strings.cartItemCountLabel.replace(
        "[count]",
        count
      );
    }
  }

  renderCart(html) {
    console.log("Rendering cart");
    this.classList.add("loading");

    this.checkGifts();

    if (html) {
      //insert cart items
      this.updateCartContent(html);

      this.postRenderFunctions();
    } else {
      fetch("/?section_id=cart-drawer")
        .then((response) => {
          return response.text();
        })
        .then((response) => {
          //insert cart items

          this.updateCartContent(response);

          this.postRenderFunctions();
        });
    }
  }

  updateCartContent(response) {
    const html = new DOMParser().parseFromString(response, "text/html");
    const itemCount = html
      .querySelector("#drawer-mini-cart")
      .getAttribute("data-item-count");

    this.updateItemCount(itemCount);

    if (
      html
        .querySelector("#drawer-mini-cart")
        .classList.contains("drawer--is-empty")
    ) {
      this.drawer.classList.add("drawer--is-empty");
    } else {
      this.drawer.classList.remove("drawer--is-empty");
    }

    const deliverySource = html.querySelector(".drawer__delivery");
    const deliveryDestination = this.querySelector(".drawer__delivery");

    if (deliverySource && deliveryDestination)
      deliveryDestination.innerHTML = deliverySource.innerHTML;

    const itemsSource = html.querySelector(".drawer__items");
    const itemsDestination = this.querySelector(".drawer__items");

    if (itemsSource && itemsDestination)
      itemsDestination.innerHTML = itemsSource.innerHTML;

    const footerSource = html.querySelector(".drawer__footer");
    const footerDestination = this.querySelector(".drawer__footer");

    if (footerSource && footerDestination)
      footerDestination.innerHTML = footerSource.innerHTML;

    this.classList.remove("loading");

    // rerender cart-drawer-upsells
    fetch("/?section_id=cart-drawer")
      .then((response) => response.text())
      .then((response) => {
        const html = new DOMParser().parseFromString(response, "text/html");
        const upsellsSource = html.querySelector("#cart-drawer-upsells");
        const upsellsDestination = document.querySelector("#cart-drawer-upsells");

        console.log(upsellsSource, upsellsDestination);

        if (upsellsSource && upsellsDestination) {
          upsellsDestination.innerHTML = upsellsSource.innerHTML;
          this.initMiniCartSlider();
        }
      });
  }

  initMiniCartSlider() {
    const sliderEl = document.querySelector('#mini-cart-slider');
    if (!sliderEl) return;

    // Destroy previous instance if exists
    if (sliderEl.splide) {
      sliderEl.splide.destroy();
    }

    // Initialize new slider
    sliderEl.splide = new Splide(sliderEl, {
      type: 'fade',
      perPage: 1,
      focus: 0,
      autoplay: true,
      arrows: true,
      pagination: true,
    }).mount();
  }


  postRenderFunctions() {
    //add event listeners
    this.addListeners();

    //update total
    this.updateTotal();
  }

  addListeners() {
    //get form elements and add event listeners
    this.giftMessageToggle = this.querySelectorAll(
      ".js-cart-drawer-gift-message-toggle"
    );
    this.giftMessageSave = this.querySelectorAll(
      ".js-cart-drawer-gift-message-save"
    );

    this.quantityInputs = this.querySelectorAll(".quantity__input");
    this.removeButtons = this.querySelectorAll("mini-cart-remove-button");
    if (this.quantityInputs) {
      this.quantityInputs.forEach((input) =>
        input.addEventListener(
          "change",
          this.handleInputChange.bind(this, input)
        )
      );
    }

    if (this.removeButtons) {
      this.removeButtons.forEach((input) =>
        input.addEventListener("click", (e) => {
          e.preventDefault();
          this.handleInputChange(null, input.getAttribute("data-key"));
        })
      );
    }

    this.giftMessageToggle.forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();

        const targetIndex = el.getAttribute("data-gift-message-target");
        const target = document.querySelector(
          '.js-cart-drawer-gift-message-wrap[data-gift-message="' +
            targetIndex +
            '"]'
        );

        if (!target) return;

        target.classList.toggle("active");
      });
    });

    this.giftMessageSave.forEach((el) => {
      el.addEventListener("click", () => {
        const message = el.previousElementSibling.value.trim();
        const key = el.getAttribute("data-item-key");
        this.cartUpdateGiftMessage(message, key);
      });
    });
  }

  cartUpdateGiftMessage(message, key) {
    const sections = ["cart-drawer"];

    this.classList.add("loading");

    fetch(`${routes.cart_url}.js`, { ...fetchConfig() })
      .then((res) => res.json())
      .then((cart) => {
        const itemToUpdate = cart.items.find((item) => item.key === key);

        if (!itemToUpdate) {
          this.classList.remove("loading");
          return;
        }

        const itemProperties = { ...itemToUpdate.properties };

        if (message === "") {
          delete itemProperties["Gift Message"];
        } else {
          itemProperties["Gift Message"] = message;
        }

        const body = JSON.stringify({
          id: key,
          properties: itemProperties,
          sections: sections,
        });

        fetch(routes.cart_change_url, { ...fetchConfig(), ...{ body } })
          .then((res) => res.json())
          .then((data) => {
            if (data.sections["cart-drawer"]) {
              this.renderCart(data.sections["cart-drawer"]);
            } else {
              this.classList.remove("loading");
            }
          })
          .catch((e) => {
            console.error(e);
            this.classList.remove("loading");
          });
      });
  }

  updateTotal() {
    //updates cart total
    const totalElements = document.querySelectorAll(".js-mini-cart-total");
    const cartTotal = document.getElementById("cart-total-hidden");

    if (totalElements && cartTotal) {
      totalElements.forEach((el) => {
        el.innerHTML = cartTotal.innerHTML;
      });
    }

    if (this.miniCartToggles.length) {
      this.miniCartToggles.forEach((el) => {
        if (parseInt(cartTotal.getAttribute("data-cart-quantity")) > 0) {
          el.classList.add("has-items");
        } else {
          el.classList.remove("has-items");
        }
      });
    }
  }

  checkGifts() {
    fetch(`${routes.cart_url}.js`, { ...fetchConfig() })
      .then((res) => res.json())
      .then((cart) => {
        const giftItems = cart.items.filter(
          (item) => item.properties["__Is Gift"] == true
        );
        if (giftItems.length) {
          giftItems.forEach((item) => {
            const giftId = item.properties["__Gift Message ID"];
            const matchingParents = cart.items.filter(
              (item) =>
                item.properties["__Is Gift Parent"] == true &&
                item.properties["__Gift Message ID"] == giftId
            );
            if (!matchingParents.length) {
              this.handleInputChange(null, item.key);
            }
          });
        }
      });
  }
}

customElements.define("mini-cart", MiniCart);
